import React, { useState } from 'react';
import { showreel } from '../mock';
import SectionHeader from './SectionHeader';
import { Play, ArrowUpRight } from 'lucide-react';

export default function Showreel() {
  const [playing, setPlaying] = useState(false);
  return (
    <section id="showreel" className="py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          kicker={showreel.kicker}
          title={showreel.title}
          description={showreel.description}
        />

        <div className="relative">
          <div className="corner-brackets">
            <span className="cb-bl" />
            <span className="cb-br" />
            <div className="aspect-video bg-neutral-900 overflow-hidden relative">
              {!playing ? (
                <>
                  <img
                    src={showreel.thumb}
                    alt="Showreel thumbnail"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40" />
                  <button
                    onClick={() => setPlaying(true)}
                    aria-label="Play showreel"
                    className="absolute inset-0 flex items-center justify-center group"
                  >
                    <span className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-[#ED2D5C] flex items-center justify-center shadow-2xl group-hover:scale-105 transition-transform">
                      <Play size={32} className="text-white fill-white ml-1" />
                    </span>
                  </button>
                </>
              ) : (
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${showreel.youtubeId}?autoplay=1`}
                  title="Showreel"
                  frameBorder="0"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </div>
          <div className="mt-3 flex items-center justify-between mono text-[10px] tracking-[0.22em] text-neutral-500">
            <span>TAP TO PLAY</span>
            <a
              href={`https://youtu.be/${showreel.youtubeId}`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 hover:text-[#ED2D5C] transition-colors"
            >
              WATCH ON YOUTUBE <ArrowUpRight size={12} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
